import { Injectable } from '@angular/core';
import { ServiceService } from './service.service';

@Injectable({
  providedIn: 'root'
})
export class TramitesService {
  constructor(private servi: ServiceService) {  }
  public getServe() { return this.servi.server; }

  //listado de solicitudes
  public getListado() { return this.servi.get('tramites/listadoTramites/'); }
  //Detalle de una solicitud de tramite
  public getDetalle(id) { return this.servi.get('tramites/detalleTramite/' + id); }
  //Estado de una solicitud de tramite
  public cambiarEstado(data) {return this.servi.post('tramites/cambiarEstado', data); }
  //
  //public getDatosSolicitud() {return this.servi.get('tramites/getDatosSolicitud'); }
  //
  public getTipoTramite(id) {return this.servi.get('tramites/getTipoTramite/' + id); }
  //Guardar solicitud de tramite
  public guardarSolicitud(data) {return this.servi.post('tramites/guardarSolicitud', data); }
  //Listado de Tipos de tramites
  public getTiposTramites() {return this.servi.get('tramites/getTiposTramites'); }
  //Estado de un tipo de tramite
  public cambiarEstadoTipoTramite(data) {return this.servi.get('tramites/cambiarEstadoTipoTramite/' + data); }
  //Guardar tipo de tramite 
  public guardarTipoTramite(datos) {return this.servi.post('tramites/guardarTipoTramite', datos); }
  //Datos de los select en creación tipo de trámite
  public getDatosSelect(){ return this.servi.get('tramites/getDatosSelect');  }
  //Detalle de un tipo de trámite
  public getDetalleTramite(id){ return this.servi.get('tramites/getDetalleTramite/' +id); } 
  
}
